<template>
	<v-dialog v-model="showDialog" persistent max-width="290">
		<v-card class="pa-4">
			<v-card-title>Select a client</v-card-title>
			<v-card-text>
				<v-select
					v-model="clientId"
					:items="allClients"
					label="Client"
					item-text="Name"
					item-value="Id"
				>
				</v-select>
			</v-card-text>
			<v-card-actions
				style="display: flex; justify-content: center; width: 100%"
			>
				<v-btn @click="onCancel">Cancel</v-btn>
				<v-btn @click="onSubmit" class="primary">Submit</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { ClientContextActions } from '../../store/actions';
import { ClientContextGetters } from '../../store/getters';
import { mapGetters } from 'vuex';

export default {
	name: 'SelectClientModal',
	props: {
		showDialog: Boolean,
	},
	data() {
		return {
			clientId: null,
		};
	},
	computed: {
		...mapGetters({
			allClients: [ClientContextGetters.CLIENTS],
		}),

		selectedClient() {
			if (this.clientId) {
				let result = this.allClients.filter(
					(t) => t.Id == this.clientId
				);
				return result;
			}
			return null;
		},
	},
	mounted() {
		let initClient = this.allClients.find((c) => c.IsSelected == true);
		if (!initClient) {
			initClient = this.allClients[0];
		}
		this.clientId = initClient.Id;
	},
	methods: {
		onCancel() {
			this.$emit('cancel');
		},
		onSubmit() {
			this.$store
				.dispatch(
					ClientContextActions.UPDATE_SELECTED_CLIENT,
					this.selectedClient[0]
				)
				.then(() => {
					this.$router.push('/homepage');
					this.$store.dispatch(
						ClientContextActions.RELOAD_CLIENT_CONTEXT
					);
				});
			this.$emit('cancel');
		},
	},
};
</script>
